import { SupportedChainId } from '../constants/chains'

const DEFAULT_NETWORKS = [
  //Feature CHAIN
  SupportedChainId.MAINNET,
  // SupportedChainId.ROPSTEN,
  // SupportedChainId.RINKEBY,
  // SupportedChainId.GOERLI,
  // SupportedChainId.KOVAN,
  SupportedChainId.SOLANA_MAINNET,
  SupportedChainId.SOLANA_TESTNET,
  SupportedChainId.SOLANA_DEVNET,
]

export function constructSameAddressMap<T extends string>(
  address: T,
  additionalNetworks: SupportedChainId[] = []
): { [chainId: number]: T } {
  return DEFAULT_NETWORKS.concat(additionalNetworks).reduce<{ [chainId: number]: T }>((memo, chainId) => {
    memo[chainId] = address
    return memo
  }, {})
}
